import { createAction } from 'typesafe-actions'
import ComparisonData from '../../../entities/ComparisonData'

export const setComparisonData = createAction('DOC / ComparisonData / set state')<ComparisonData>()

export const resetComparisonData = createAction('DOC / ComparisonData / reset state')()
